import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from './analytics';

function EmptyBattery() {
    return (
        <div className="charging-battery" aria-label="Empty battery">
            <div className="battery-body">
                <div className="battery-fill" style={{ width: '4%' }} />
                <span className="battery-pct">0%</span>
            </div>
            <div className="battery-tip" />
        </div>
    );
}

export default function ChargingPage() {
    const [searching, setSearching] = React.useState(false);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        trackEvent('page_view', 'charging');
    }, []);

    const findGasStation = () => {
        setSearching(true);
        setError(null);

        if (!navigator.geolocation) {
            // Fallback: open Google Maps gas station search without location
            window.open('https://www.google.com/maps/search/gas+station+near+me', '_blank');
            setSearching(false);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const { latitude, longitude } = pos.coords;
                trackEvent('gas_station_search', 'with_location');
                const url = `https://www.google.com/maps/search/gas+station/@${latitude},${longitude},15z`;
                window.open(url, '_blank');
                setSearching(false);
            },
            () => {
                // Permission denied or unavailable — fall back to generic search
                trackEvent('gas_station_search', 'fallback');
                window.open('https://www.google.com/maps/search/gas+station+near+me', '_blank');
                setSearching(false);
            },
            { timeout: 8000 }
        );
    };

    return (
        <div className="loc-page fade-in">
            {/* Back nav */}
            <div className="nav-header">
                <Link to="/" className="back-link">← Back</Link>
            </div>

            {/* Hero */}
            <section className="loc-hero charging-hero">
                <EmptyBattery />
                <h1 className="loc-title charging-title">
                    Uh oh. 🪫
                </h1>
                <p className="charging-sorry">
                    Sorry, looks like you're running on empty.
                </p>
                <p className="loc-subtitle">
                    No worries — we'll help you find the nearest place to fuel up.
                </p>
            </section>

            {/* CTA */}
            <section className="charging-cta-section">
                <div className="charging-card">
                    <p className="charging-card-label">⛽ Need a charge?</p>
                    <p className="charging-card-body">
                        Tap below and we'll pull up the closest gas station to your current location.
                    </p>
                    <button
                        className="charging-find-btn"
                        onClick={findGasStation}
                        disabled={searching}
                    >
                        {searching ? 'Locating…' : '📍 Find Nearest Gas Station'}
                    </button>
                    {error && <p className="charging-error">{error}</p>}
                </div>
            </section>
        </div>
    );
}
